import {
  LineItemPropertiesUpdateContext,
  proposeLineItemProperties,
  type LineItemPropertiesUpdateEvent,
} from '../line-item-properties-update-chain';

function needsPromotionCleanup(
  line: LineItemPropertiesUpdateContext['cart']['items'][number],
): boolean {
  if (!line.properties) return false;
  if (line.quantity >= 3) return false;

  const promotion = line.properties['Promotion'];
  if (typeof promotion !== 'string') return false;

  return promotion.trim().length > 0;
}

export const promotionLabelQuantityRule = (): LineItemPropertiesUpdateEvent => {
  return async (ctx) => {
    for (const line of ctx.cart.items) {
      if (!line.key) continue;
      if (!needsPromotionCleanup(line)) continue;

      proposeLineItemProperties(ctx, line.key, {
        Promotion: null,
      });
    }

    return ctx;
  };
};
